import { AvailableChildrenType, SugarElementInfo } from "../../Suggester/SugarElementInfo";

export const sub: SugarElementInfo = { name: "sub", availableChildren: { type: AvailableChildrenType.Any } };
